import { ViziAPI } from "../apollo/setupViziClient";
import { CREATE_PLANO_VIZI, UPDATE_PLANO_VIZI } from "../graphql/mutations";
import { FIND_ALL_PLANO_VIZI } from "../graphql/queryes";


export const findAllPlanoVizi = async (variables,whitelabel) => {
   const { data } =
      ViziAPI.defaults.headers['whitelabel'] = whitelabel;
      const response = await ViziAPI.post("", {
        query: FIND_ALL_PLANO_VIZI,
        variables: variables
      });

   if (data?.errors) {
    throw new Error(data.errors[0].message);
  }

  return response.data.data.findAllPlanoVizi;
  };
export const createPlanoVizi = async (variables, whitelabel) => {
    
      ViziAPI.defaults.headers['whitelabel'] = whitelabel;
      const response = await ViziAPI.post("", {
        query: CREATE_PLANO_VIZI,
        variables: variables
      });
     
   if (response.data?.errors) {
    throw new Error(response.data.errors[0].message);
  }

  return response.data.data.createPlanoVizi;
  };

export const updatePlanoVizi = async (variables, whitelabel, callback) => {
      ViziAPI.defaults.headers['whitelabel'] = whitelabel;
      const response = await ViziAPI.post("", {
        query: UPDATE_PLANO_VIZI,
        variables: variables
      });
    if (response.data?.errors) {
    throw new Error(response.data.errors[0].message);
  }

  return response.data.data.updatePlanoVizi;
  };

